// src/redux/slices/uiSlice.js
import { createSlice } from '@reduxjs/toolkit'

const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        loading: 0,
        toast: null,
        sidebarOpen: false
    },
    reducers: {
        showLoading: (state) => {
            state.loading += 1
        },
        hideLoading: (state) => {
            state.loading = Math.max(0, state.loading - 1)
        },
        showToast: (state, action) => {
            state.toast = action.payload
        },
        hideToast: (state) => {
            state.toast = null
        },
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen
        },
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload
        }
    }
})

export const {
    showLoading,
    hideLoading,
    showToast,
    hideToast,
    toggleSidebar,
    setSidebarOpen
} = uiSlice.actions

export default uiSlice.reducer